import { useContext } from 'react';
import { Context } from '../../context/AppContextBuilder';
import { InterviewContext } from '../../context/InterviewContext';
import { CancelledInterviewTemplate } from '../../templates/CanceledTemplate';

export const FAQError = () => {
  const { emiPrefix, tryAgain } = useContext(Context);
  document.title = `${emiPrefix} ${tryAgain}`;
  const { mroPhoneNumber } = useContext(InterviewContext);
  return <CancelledInterviewTemplate faqError phone={mroPhoneNumber} />;
};
